import { forwardRef } from 'react';

import { isCurrentPath } from '@openclassrooms/routing';

import Typography from '@classify/react-core-components/Typography';

import MainHeaderNavigationLink from '../MainHeaderNavigationLink';
import StyledListItem from './StyledListItem';
import StyledListItemText from './StyledListItemText';

interface Props {
  link: {
    path: any;
    content: any;
    dataEvent?: 'string';
    shouldUseHref?: boolean;
    shouldBeDisplayed?: boolean;
    dataTestId?: string;
    linkAttributes?: {};
  };
  isLegacy?: boolean;
  onClickAction?: () => void;
  isSubMenuItem?: boolean;
}

const LinkListItem = ({ link, isLegacy, onClickAction, isSubMenuItem }: Props) => {
  const { path, content, dataEvent, shouldUseHref, linkAttributes } = link;

  const linkProps = {
    isLegacy,
    path,
    dataEvent,
    shouldUseHref,
    onClickAction,
    linkAttributes,
  };

  const ListItemComponent = forwardRef((props, ref) => (
    <div ref={ref}>
      <MainHeaderNavigationLink {...props} {...linkProps} />
    </div>
  ));

  return (
    <StyledListItem component={ListItemComponent} button sx={{ my: isSubMenuItem ? 0 : 1 }}>
      <StyledListItemText
        sx={{
          color: isCurrentPath(path, true) ? 'palette.primary.main' : null,
        }}
        primary={
          <Typography variant="body" component="span">
            {content}
          </Typography>
        }
      />
    </StyledListItem>
  );
};

export default LinkListItem;
